/**
 * 意图识别中转页
 */
import React from 'react';

const SearchStation = ({ text = '' }) => {
  return (
    <div className="absolute inset-0 size-full bg-white z-11 pt-76px">
      <div className="size-full mx-auto max-w-1060px px-24px">
        <div
          className={[
            text.length > 40 ? 'text-24px' : 'text-32px',
            'w-636px leading-normal mb-28px font-extrabold break-all',
          ]}
        >
          <div className="">{text}</div>
          <div className="w-full h-48px flex items-center pl-20px mt-17px rounded-8px bg-[#F5F5F5]">
            <img
              src="https://p4.ssl.qhimg.com/t11098f6bcdced700e03b711ad3.png"
              className="size-16px transform animate-spin"
              alt=""
            />
            <div className="text-14px font-bold ml-8px">
              正在识别意图，为您匹配最优方案
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SearchStation;